export enum UserPrivilege {
  // root privileges
  AUTH = 'auth',
  SETTINGS = 'settings',

  // customer privileges
  CUSTOMER = 'customer',
  CUSTOMER_ADDRESS = 'customer-address',
  CUSTOMER_CONTACT = 'customer-contact',
  CUSTOMER_QUOTE = 'customer-quote',
  CUSTOMER_ORDER = 'customer-order',
  CUSTOMER_SERVICE = 'customer-service',

  // partner privileges
  PARTNER = 'partner',
  ADDRESS = 'address',
  PARTNER_AGREEMENT = 'partner-agreement',
  USER = 'user',
  CONTACT = 'contact',
  QUOTE = 'quote',
  ORDER = 'order',
  ORDERLINE = 'orderline',
  INVOICE = 'invoice',

  // provisioning privileges
  PROVISIONING_PARTITION = 'provisioning-partition',
  PROVISIONING_SERVICE = 'provisioning-service',
  PROVISIONING_PHONE_NUMBER = 'provisioning-phone-number',
  PROVISIONING_PHONE_NUMBER_RANGE = 'provisioning-phone-number-range',
  PROVISIONING_BUNDLE = 'provisioning-bundle',
}
